/**
 * CRM 빌드 버전.
 * 로그인 화면과 헤더에서 표시되며, Preview / Production 환경 배포 확인 용도.
 * 릴리스 시 package.json 과 함께 업데이트.
 */
export const CRM_VERSION = '1.0.0';
